import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 relative z-10 bg-[#0a0a0a] border-t border-white/5" data-id="element-14">
      <div className="max-w-7xl mx-auto px-6" data-id="element-15">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-16">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-17">
            <h2 className="text-4xl md:text-5xl font-black text-white mb-6" data-id="element-18">
              Get Your Free <br data-id="element-19" /> Quote Today
            </h2>
            <p className="text-gray-400 text-lg mb-12" data-id="element-20">
              Whether you need an emergency repair or a quote for a new boiler,
              our team is ready to help.
            </p>

            <div className="space-y-8" data-id="element-21">
              <div className="flex items-start gap-4" data-id="element-22">
                <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0" data-id="element-23">
                  <Phone className="w-5 h-5 text-[#FFD600]" data-id="element-24" />
                </div>
                <div data-id="element-25">
                  <h4 className="text-white font-bold mb-1" data-id="element-26">Call Us (24/7)</h4>
                  <a href="tel:07845242803" className="text-gray-400 hover:text-[#FFD600] transition-colors text-lg" data-id="element-27">
                    07845 242803
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-28">
                <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0" data-id="element-29">
                  <Mail className="w-5 h-5 text-[#FFD600]" data-id="element-30" />
                </div>
                <div data-id="element-31">
                  <h4 className="text-white font-bold mb-1" data-id="element-32">Email Us</h4>
                  <a href="mailto:Clydesidegasandheating@gmail.com" className="text-gray-400 hover:text-[#FFD600] transition-colors break-all" data-id="element-33">
                    Clydesidegasandheating@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-34">
                <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0" data-id="element-35">
                  <Clock className="w-5 h-5 text-[#FFD600]" data-id="element-36" />
                </div>
                <div data-id="element-37">
                  <h4 className="text-white font-bold mb-1" data-id="element-38">Working Hours</h4>
                  <p className="text-gray-400" data-id="element-39">Mon - Fri: 8:00 AM - 6:00 PM</p>
                  <p className="text-gray-400" data-id="element-40">Sat: 9:00 AM - 4:00 PM</p>
                  <p className="text-[#FFD600] font-medium mt-1" data-id="element-41">
                    24/7 Emergency Callouts Available
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-card border border-white/10 rounded-3xl p-8" data-id="element-42">
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-43">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-44">
                <div className="space-y-2" data-id="element-45">
                  <label className="text-sm font-medium text-gray-400" data-id="element-46">
                    Full Name
                  </label>
                  <input type="text" className="w-full bg-[#0a0a0a] border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#FF9500] transition-colors" placeholder="John Doe" data-id="element-47" />
                </div>
                <div className="space-y-2" data-id="element-48">
                  <label className="text-sm font-medium text-gray-400" data-id="element-49">
                    Phone Number
                  </label>
                  <input type="tel" className="w-full bg-[#0a0a0a] border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#FF9500] transition-colors" placeholder="07123 456789" data-id="element-50" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-51">
                <label className="text-sm font-medium text-gray-400" data-id="element-52">
                  Email Address
                </label>
                <input type="email" className="w-full bg-[#0a0a0a] border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#FF9500] transition-colors" placeholder="john@example.com" data-id="element-53" />
              </div>

              <div className="space-y-2" data-id="element-54">
                <label className="text-sm font-medium text-gray-400" data-id="element-55">
                  Service Required
                </label>
                <select className="w-full bg-[#0a0a0a] border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#FF9500] transition-colors appearance-none" data-id="element-56">
                  <option data-id="element-57">Boiler Installation</option>
                  <option data-id="element-58">Boiler Repair</option>
                  <option data-id="element-59">Servicing & Maintenance</option>
                  <option data-id="element-60">Gas Safety Certificate</option>
                  <option data-id="element-61">Emergency Callout</option>
                  <option data-id="element-62">Other</option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-63">
                <label className="text-sm font-medium text-gray-400" data-id="element-64">
                  Message
                </label>
                <textarea rows={4} className="w-full bg-[#0a0a0a] border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#FF9500] transition-colors resize-none" placeholder="Tell us about your heating issue..." data-id="element-65"></textarea>
              </div>

              <button type="submit" className="w-full bg-gradient-primary text-black font-bold text-lg py-4 rounded-xl hover:shadow-[0_0_20px_rgba(255,149,0,0.3)] transition-all duration-300" data-id="element-66">
                Send Message
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}